import CheckMarkFormatter from "./CheckMarkFormatter";

const ChronicConditionsCheckMarkFormatter = ({ value }) => {
  const isChecked = value?.length > 0 && value !== "Remove From List";
  return CheckMarkFormatter({ value: isChecked });
};

export default ChronicConditionsCheckMarkFormatter;
